import { ChatParticipant } from '@tribeplatform/gql-client/types'
import { useMember } from '@tribeplatform/react-sdk/hooks'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

interface Props {
  participant: ChatParticipant
}

export const ModalMemberDetails = ({ participant }: Props) => {
  const { data: member, isLoading: isMemberLoading } = useMember({
    variables: {
      id: participant.memberId,
    },
  })

  return (
    <div className="flex items-center gap-2">
      <Avatar size="4x" src={participant.avatarUrl} name={participant.name} />
      <div className="flex flex-col gap-1">
        <span className="font-bold">{participant.name}</span>
        <span className="text-sm text-gray-500">
          {isMemberLoading && (
            <div className="h-4 bg-skeleton rounded-base w-32 animate-pulse"></div>
          )}
          {!isMemberLoading && member?.email}
        </span>
      </div>
    </div>
  )
}
